import script from "./TabReferencias.vue?vue&type=script&setup=true&lang=js"
export * from "./TabReferencias.vue?vue&type=script&setup=true&lang=js"

import "./TabReferencias.vue?vue&type=style&index=0&id=5d43ef99&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d43ef99"]])

export default __exports__